import { isDefined } from "@clipboard-health/util-ts";
import { Box, Stack } from "@mui/material";
import Message from "@sendbird/uikit-react/Channel/components/Message";
import { type EveryMessage } from "@sendbird/uikit-react/types/types";
import { type SendableMessageType } from "@sendbird/uikit-react/types/utils";

import { isValidJson } from "./utils";

interface OutgoingUserChatMessageProps {
  message: SendableMessageType;
}

export function OutgoingUserChatMessage(props: OutgoingUserChatMessageProps) {
  const { message } = props;
  const { sender, data } = message;

  if (isValidJson(data)) {
    const parsedData = JSON.parse(data) as { workplaceUserName: string };
    if (isDefined(parsedData.workplaceUserName)) {
      sender.nickname = parsedData.workplaceUserName;
    }
  }

  return (
    <Stack alignItems="flex-end">
      {/* Apply Sendbird's default styling for sender name */}
      <Box sx={{ display: "inline-flex", marginRight: "12px", marginBottom: "4px" }}>
        <span className="sendbird-message-content__middle__sender-name sendbird-label sendbird-label--caption-2 sendbird-label--color-onbackground-2">
          {sender.nickname}
        </span>
      </Box>
      <Message message={message as EveryMessage} />
    </Stack>
  );
}
